import { render, staticRenderFns } from "./EditConfigFile.vue?vue&type=template&id=0a7098e8&scoped=true&"
import script from "./EditConfigFile.vue?vue&type=script&lang=js&"
export * from "./EditConfigFile.vue?vue&type=script&lang=js&"
import style0 from "./EditConfigFile.vue?vue&type=style&index=0&id=0a7098e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7098e8",
  null
  
)

export default component.exports